import { render, staticRenderFns } from "./formEmployeeNew.vue?vue&type=template&id=5b533de2&scoped=true&"
import script from "./formEmployeeNew.vue?vue&type=script&lang=js&"
export * from "./formEmployeeNew.vue?vue&type=script&lang=js&"
import style0 from "./formEmployeeNew.vue?vue&type=style&index=0&id=5b533de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b533de2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b533de2')) {
      api.createRecord('5b533de2', component.options)
    } else {
      api.reload('5b533de2', component.options)
    }
    module.hot.accept("./formEmployeeNew.vue?vue&type=template&id=5b533de2&scoped=true&", function () {
      api.rerender('5b533de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/formEmployeeNew.vue"
export default component.exports